var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"scroller",class:{ 'is-draging': _vm.isDraging === true },on:{"scroll":_vm.onScroll}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }